import React = require("react");
import {GaugeColors} from "../../../../../../components/Utils/color/ColorUtils";
import {JSONWashesWidgetTexts} from "../../CoffeeMachineDashboard";
import {LinearGaugeWithRange} from "../LinearGaugeWithRange";
import {Widget, WidgetProps} from "./Widget";
import {VeBoxCard} from "../../../../../../components/card/VeBoxCard";
import AutoSizer from "react-virtualized-auto-sizer";

interface Data {
    automaticWashesAvg: number;
    manualWashesAvg: number;
    purgesPerc: number;
    numberActiveDays: number;
}

interface WashesWidgetProps extends WidgetProps {
    texts: JSONWashesWidgetTexts;
    data: Data;
}

export class WashesWidget extends Widget<WashesWidgetProps, any> {

    constructor(props) {
        super(props);
    }

    public widgetRender() {
        const washesRanges = [];
        washesRanges.push({color: GaugeColors.RED, fromValue: 0, toValue: 0.7});
        washesRanges.push({color: GaugeColors.ORANGE, fromValue: 0.7, toValue: 0.85});
        washesRanges.push({color: GaugeColors.GREEN, fromValue: 0.85, toValue: 1});

        const purgesRanges = [];
        purgesRanges.push({color: GaugeColors.RED, fromValue: 0, toValue: 60});
        purgesRanges.push({color: GaugeColors.ORANGE, fromValue: 60, toValue: 80});
        purgesRanges.push({color: GaugeColors.GREEN, fromValue: 80, toValue: 100});
        return (
            <VeBoxCard className="washes-widget no-margin">
                <VeBoxCard.Header title={this.props.texts.title} singleLineTitle={true}/>
                <VeBoxCard.Body className="washes-widget__container no-padding" style={{paddingBottom: 10}}>
                    <div className="washes-widget__content">
                        <p className="washes-widget__info">
                            {this.props.texts.activeDays}: {this.props.data.numberActiveDays}
                        </p>
                        <div className="double_linear-gauge__container">
                            <AutoSizer disableHeight style={{width: "auto", height: "auto"}}>
                                {({width}) =>
                                    <>
                                        <p className="linear-gauge__title">{this.props.texts.avgWashesByDay}</p>
                                        <div>
                                            <div className="linear_wash_type">Auto</div>
                                            <div className="linear_wash_chart">
                                                <LinearGaugeWithRange
                                                    size={{width: width - 50, height: 70}}
                                                    value={this.props.data.automaticWashesAvg}
                                                    minValue={0}
                                                    maxValue={1}
                                                    unitOfMeasure={""}
                                                    ranges={washesRanges}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className="linear_wash_type">Man</div>
                                            <div className="linear_wash_chart">
                                                <LinearGaugeWithRange
                                                    size={{width: width - 50, height: 70}}
                                                    value={this.props.data.manualWashesAvg}
                                                    minValue={0}
                                                    maxValue={1}
                                                    unitOfMeasure={""}
                                                    ranges={washesRanges}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </AutoSizer>
                        </div>
                        <div className="linear-gauge__container">
                            <AutoSizer disableHeight style={{width: "auto", height: "auto"}}>
                                {({width}) =>
                                    <>
                                        <p className="linear-gauge__title">{this.props.texts.purgePercentageByConsumption}</p>
                                        <LinearGaugeWithRange
                                            size={{width: width, height: 65}}
                                            value={this.props.data.purgesPerc}
                                            minValue={0}
                                            maxValue={100}
                                            unitOfMeasure="%"
                                            ranges={purgesRanges}
                                        />
                                    </>
                                }
                            </AutoSizer>
                        </div>
                    </div>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }
}
